import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'si-check-box',
  imports: [FormsModule, CommonModule,MatCheckboxModule],
  templateUrl: './si-check-box.component.html',
  styleUrl: './si-check-box.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SiCheckBoxComponent),
      multi: true
    }
  ]
})
export class SiCheckBoxComponent implements ControlValueAccessor {

  private onModelChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  private inputDisabled = false;
  private cvaDisabled = false;
  effectiveDisabled = false;

  @Input() displayText: string | undefined | number;
  @Input() isReadMode: boolean = true;
  @Input()
  set isDisabled(value: boolean) {
    this.inputDisabled = !!value;
    this.syncDisabledState();
  }
  get isDisabled(): boolean {
    return this.inputDisabled;
  }
  @Input() isChecked: boolean = false;
  @Output('change') checkedChange = new EventEmitter<boolean>();

  onInternalChange(checked: boolean): void {
    this.isChecked = checked;
    this.onModelChange(checked);
    this.onTouched();
    this.checkedChange.emit(checked);
  }

  writeValue(value: boolean | null): void {
    this.isChecked = !!value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.cvaDisabled = !!isDisabled;
    this.syncDisabledState();
  }

  private syncDisabledState(): void {
    this.effectiveDisabled = this.inputDisabled || this.cvaDisabled;
  }
}
